export default __webpack_public_path__ + "static/media/exata.48132be3.png";